import { Suspense } from 'react';
import styled from 'styled-components';

import { useFeatureFlags } from '#src/hooks/useFeatureFlags.tsx';
import { lazy } from '#src/lib/retry.ts';

const ShaderWrapper = styled.div`
  position: absolute;
  inset: 0;
`;

const Shader = lazy(async () =>
  import('@sorare/trois/src/components/BokehBackground').then(module => ({
    default: module.BokehBackground,
  }))
);
type Props = {
  style?: React.CSSProperties;
  className?: string;
} & React.ComponentProps<typeof Shader>;

export const BokehBackground = ({ style, className, ...props }: Props) => {
  const {
    flags: { useBokehBackground = false },
  } = useFeatureFlags();

  if (!useBokehBackground) {
    return null;
  }

  return (
    <ShaderWrapper style={style} className={className}>
      <Suspense fallback={null}>
        <Shader {...props} />
      </Suspense>
    </ShaderWrapper>
  );
};
